/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/19/20
 *
 */

//CustomEvent Polyfill https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
import {isDevEnv} from "@/utils/helpers";
import CommonObject from "@shared/CommonObject";

let paddleSetupCalled = false;

(function () {

	if (typeof window.CustomEvent === "function") return false;

	function CustomEvent(event, params) {
		params = params || {bubbles: false, cancelable: false, detail: null};
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	window.CustomEvent = CustomEvent;
})();


let attemptLimit = 10
let attempt = 0
let isSetupCompleted = false
let paddleReadyResolver = null
let paddleReadyPromise = new Promise(resolve => {
	paddleReadyResolver = resolve
})

export function trySetupPaddle(){
	//prevents race condition since this function is called from multiple places
	if(paddleSetupCalled){
		return
	}
	paddleSetupCalled = true
	_trySetupPaddleInternal()
}

export function trySetupPaddleForce(){
	attempt = 0
	_trySetupPaddleInternal()
}

export function waitForPaddleReady(){
	if(window.Paddle && window.Paddle.Checkout){
		return Promise.resolve(true)
	}
	window.addEventListener('paddle-loaded', () => {
		trySetupPaddleForce()
	}, {once: true})
	return paddleReadyPromise.then(() => true)
}

function _trySetupPaddleInternal(){
	if(isSetupCompleted){
		return
	}
	if(attempt > attemptLimit){
		console.log("trySetupPaddle failed: attempts limit exceeded")
		CommonObject.analyticManager.trackEvent("trySetupPaddle failed: attempts limit exceeded")
		return
	}
	if(window.Paddle && window.Paddle.Setup){
		setupPaddle()
		console.log("setupPaddle completed");
		if(attempt > 0) {
			CommonObject.analyticManager.trackEvent("trySetupPaddle completed")
		}
		isSetupCompleted = true
	} else {
		attempt++
		setTimeout(_trySetupPaddleInternal, 1000)
		console.log("trySetupPaddle failed")
		CommonObject.analyticManager.trackEvent("trySetupPaddle failed")
	}
}

function setupPaddle(){
	let vendorId = Number(process.env.VUE_APP_PADDLE_VENDOR_ID)
	if(isDevEnv && window.Paddle && window.Paddle.Environment){
		window.Paddle.Environment.set('sandbox');
	}

	console.log("setupPaddle.js: setting up paddle with vendorId = ", vendorId)

	window.Paddle.Setup({
		vendor: vendorId,
		eventCallback(data) {
			console.log("setupPaddle.js: paddle eventCallback, data = ", data);
			let event = new CustomEvent('paddle_checkout_event', {detail: data});
			document.dispatchEvent(event);
		}
	})
	if(paddleReadyResolver){
		paddleReadyResolver(true)
	}
	window.dispatchEvent(new Event('paddle-ready'))

}

window.trySetupPaddle = trySetupPaddle
